import confetti from "canvas-confetti";

export function useConfettiCelebration() {
  const DURATION = 4 * 1000;
  const COLORS = [
    "#a25afd",
    "#26ccff",
    "#ff5e7e",
    "#88ff5a",
    "#fcff42",
    "#ffa62d",
    "#ff36ff",
  ];

  function randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  let animationEnd = 0;
  let skew = 1;

  const { resume, pause } = useRafFn(
    ({ timestamp }) => {
      if (timestamp > animationEnd) {
        return pause();
      }

      const timeLeft = animationEnd - timestamp;
      const ticks = Math.max(100, 500 * (timeLeft / DURATION));
      skew = Math.max(0.8, skew - 0.001);

      confetti({
        particleCount: 1,
        startVelocity: 0,
        ticks: ticks,
        origin: {
          x: Math.random(),
          y: Math.random() * skew - 0.2,
        },
        gravity: randomInRange(0.5, 0.8),
        scalar: randomInRange(1, 2),
        drift: randomInRange(-0.5, 0.5),
        colors: [COLORS[Math.floor(Math.random() * COLORS.length)]],
      });
    },
    { immediate: false },
  );

  function celebrate() {
    animationEnd = performance.now() + DURATION;
    resume();
  }

  onUnmounted(() => {
    confetti.reset();
    pause();
  });

  return {
    celebrate,
  };
}
